import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function BookOpenOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_60)'>
        <path
          d='M20.6198 4.22003C20.5036 4.12605 20.3679 4.05931 20.2225 4.02469C20.0771 3.99008 19.9259 3.98849 19.7798 4.02003L11.9998 5.77003L4.21981 4.00003C4.07144 3.96652 3.91737 3.9673 3.76935 4.00231C3.62132 4.03732 3.48323 4.10564 3.36558 4.20207C3.24794 4.2985 3.15385 4.4205 3.09046 4.55877C3.02708 4.69705 2.99608 4.84797 2.99981 5.00003V17.2C2.99416 17.4312 3.0688 17.6572 3.21101 17.8395C3.35323 18.0218 3.55423 18.1492 3.77981 18.2L11.7798 20H12.2198L20.2198 18.2C20.4454 18.1492 20.6464 18.0218 20.7886 17.8395C20.9308 17.6572 21.0055 17.4312 20.9998 17.2V5.00003C20.9991 4.84983 20.9646 4.70171 20.8988 4.56667C20.833 4.43164 20.7377 4.31316 20.6198 4.22003ZM4.99981 6.25003L10.9998 7.60003V17.75L4.99981 16.4V6.25003ZM18.9998 16.4L12.9998 17.75V7.60003L18.9998 6.25003V16.4Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_60'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
